var _g, _rect, _g2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleStudyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 84,
    viewBox: "0 0 113 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9683_24036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0956 56.0586C80.0956 54.896 80.2828 53.9265 80.6572 53.1503C81.0307 52.3741 81.7999 51.5005 82.9649 50.5294C83.7741 49.8311 84.3833 49.1689 84.7923 48.5426C85.2014 47.9164 85.406 47.2105 85.406 46.425C85.406 45.2954 84.9978 44.3548 84.1814 43.6032C83.365 42.8524 82.2494 42.477 80.8346 42.477C79.6839 42.477 78.767 42.7321 78.084 43.2422C77.4011 43.7523 76.8519 44.387 76.4366 45.1463L75 44.5057C75.57 43.4269 76.3321 42.5728 77.2863 41.9431C78.2405 41.3144 79.4233 41 80.8346 41C82.8088 41 84.3304 41.5381 85.3993 42.6143C86.4682 43.6905 87.0018 44.9505 87 46.3945C87 47.3241 86.787 48.1728 86.361 48.9405C85.9342 49.7091 85.3117 50.4395 84.4935 51.1318C83.2681 52.1606 82.4958 52.9995 82.1765 53.6486C81.8582 54.2977 81.699 55.1006 81.699 56.0573L80.0956 56.0586ZM80.8373 63C80.4798 63 80.1681 62.8733 79.9022 62.6199C79.6354 62.3666 79.502 62.0696 79.502 61.7289C79.502 61.3883 79.6354 61.0912 79.9022 60.8379C80.169 60.5845 80.4802 60.4578 80.8359 60.4578C81.1916 60.4578 81.5038 60.5845 81.7723 60.8379C82.0409 61.0912 82.1739 61.3883 82.1712 61.7289C82.1685 62.0696 82.0351 62.3666 81.771 62.6199C81.5069 62.8733 81.1956 63 80.8373 63Z",
    fill: "#C691FB"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 20.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#C691FB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9683_24036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0956 36.0586C31.0956 34.896 31.2828 33.9265 31.6572 33.1503C32.0307 32.3741 32.7999 31.5005 33.9649 30.5294C34.7741 29.8311 35.3833 29.1689 35.7923 28.5426C36.2014 27.9164 36.406 27.2105 36.406 26.425C36.406 25.2954 35.9978 24.3548 35.1814 23.6032C34.365 22.8524 33.2494 22.477 31.8346 22.477C30.6839 22.477 29.767 22.7321 29.084 23.2422C28.4011 23.7523 27.8519 24.387 27.4366 25.1463L26 24.5057C26.57 23.4269 27.3321 22.5728 28.2863 21.9431C29.2405 21.3144 30.4233 21 31.8346 21C33.8088 21 35.3304 21.5381 36.3993 22.6143C37.4682 23.6905 38.0018 24.9505 38 26.3945C38 27.3241 37.787 28.1728 37.361 28.9405C36.9342 29.7091 36.3117 30.4395 35.4935 31.1318C34.2681 32.1606 33.4958 32.9995 33.1765 33.6486C32.8582 34.2977 32.699 35.1006 32.699 36.0573L31.0956 36.0586ZM31.8373 43C31.4798 43 31.1681 42.8733 30.9022 42.6199C30.6354 42.3666 30.502 42.0696 30.502 41.7289C30.502 41.3883 30.6354 41.0912 30.9022 40.8379C31.169 40.5845 31.4802 40.4578 31.8359 40.4578C32.1916 40.4578 32.5038 40.5845 32.7723 40.8379C33.0409 41.0912 33.1739 41.3883 33.1712 41.7289C33.1685 42.0696 33.0351 42.3666 32.771 42.6199C32.5069 42.8733 32.1956 43 31.8373 43Z",
    fill: "#C691FB"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#C691FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9683_24036"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 20,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9683_24036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleStudyIcon);
export default __webpack_public_path__ + "static/media/double_study_icon.370eddc694f592c782e9bb531cf65693.svg";
export { ForwardRef as ReactComponent };